module.exports = __webpack_public_path__ + "static/media/Project2-SpotiTom clone.04279227.webp";